export default __webpack_public_path__ + "static/media/bg_enable_big.91130d1b.svg";